import { useEffect, useRef, useState, type ReactNode } from "react";
import { Schwebend } from "./Schwebend";
import s from "./ui.module.css";

/** Hilfe „?“ neben einem Seitentitel (BAUPLAN-SPRINT-KOPF.md, Abschnitt 1): leiser Symbolknopf mit 44 px Trefferfläche. Er öffnet den
 *  Text in `Schwebend`, statt dass er dauerhaft auf der Seite steht. Esc und Klick daneben schließen, Esc gibt den Fokus an den Knopf
 *  zurück. `label` ist der Name des Knopfs und des Fensters, zum Beispiel „Erklärung zum Sprint“. */
export function Hilfe({ label, children }: { label: string; children: ReactNode }) {
  const knopf = useRef<HTMLButtonElement>(null);
  const text = useRef<HTMLDivElement>(null);
  const [offen, setOffen] = useState(false);

  // Fokus in den Text, damit Esc dort greift und Screenreader ihn gleich vorlesen
  useEffect(() => {
    if (offen) text.current?.focus({ preventScroll: true });
  }, [offen]);

  return (
    <>
      <button
        ref={knopf}
        type="button"
        className={s.hilfeKnopf}
        aria-label={label}
        title={label}
        aria-haspopup="dialog"
        aria-expanded={offen}
        onClick={() => setOffen(!offen)}
        onKeyDown={(e) => {
          if (e.key === "Escape" && offen) {
            e.preventDefault();
            setOffen(false);
          }
        }}
      >
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <circle cx="12" cy="12" r="9" />
          <path d="M9.1 9a3 3 0 0 1 5.8 1c0 2-3 3-3 3" />
          <path d="M12 17h.01" />
        </svg>
      </button>
      <Schwebend anker={knopf} offen={offen} onSchliessen={() => setOffen(false)} label={label} breite={380}>
        <div ref={text} tabIndex={-1} className={s.hilfeText}>
          {children}
        </div>
      </Schwebend>
    </>
  );
}
